module.exports = __webpack_public_path__ + "assets/img/logo.150a0049.png";